import { AbstractControl, ValidationErrors } from '@angular/forms';
import { LoyaltyProgramProductAddress } from '@src/app/modules/loyalty-program/models';

export const mapObjectValidator = (mapObjectsControl: AbstractControl): ValidationErrors | null => {
  const mapObjects: LoyaltyProgramProductAddress[] | undefined = mapObjectsControl.value;

  if (mapObjects?.length) {
    for (let index = 0; index < mapObjects.length; index++) {
      const { latitude, longitude } = mapObjects[index];

      if (!latitude || !longitude) {
        return { coordinatesRequired: true };
      }
    }
  }

  return null;
};
